<script>
  import { onMount } from 'svelte';
  import ajaxFetch from '../services/ajaxFetch.js';
  import ComparisonTable from './ComparisonTable.svelte';

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

  /*                */
  let {
    variationId,
    featureIndex,
    eventMergeId = null,
    cinemaInjectionContainerWidth = 1000
  } = $props();

  let featuresState = $state(),
    recommendations = $state(),
    headline = $state(),
    mainVariation = $state(),
    tracking = $state(),
    additionalClickTracking = $state();

  onMount(async () => {
    const res = await ajaxFetch(
      `/reco-core/recommendations/comparealternatives/variations/${variationId}`
    );
    if (res.status !== 200) {
      return;
    }
    try {
      ({
        headline,
        mainVariation,
        recommendations,
        tracking,
        featuresState,
        additionalClickTracking
      } = await res.json());
    } catch (e) {
      console.error('Error parsing recommendations:', e);
      return;
    }
  });
</script>

{#if recommendations && recommendations.length > 0}
  <h2 class="reco_comparison__comparison_table__headline oc-headline-100 oc-headline-200--l">
    {headline}
  </h2>
  <ComparisonTable
    {mainVariation}
    {recommendations}
    {featuresState}
    {featureIndex}
    {cinemaInjectionContainerWidth}
    {tracking}
    trackingEventMergeId={eventMergeId}
    {additionalClickTracking}></ComparisonTable>
{/if}

<style lang="scss">
  .reco_comparison__comparison_table__headline {
    padding: 24px 16px 0 16px;
  }
</style>
